var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Graphs_element;
import Chart from 'chart.js/auto';
/**
 * Navigation bar functionality
 * @class
 */
class Graphs {
    //   dropdowns: NodeListOf<Element>;
    //   links: NodeListOf<Element>;
    /**
     * @constructor
     * @param {HTMLElement} element The navigation bar root element
     */
    constructor(element) {
        _Graphs_element.set(this, void 0);
        __classPrivateFieldSet(this, _Graphs_element, element, "f");
        this.canvas = __classPrivateFieldGet(this, _Graphs_element, "f").querySelector('[data-component="GraphCanvas"]');
        this.data = __classPrivateFieldGet(this, _Graphs_element, "f").querySelectorAll('[data-component="GraphItem"]');
        const type = __classPrivateFieldGet(this, _Graphs_element, "f").getAttribute('data-type');
        //console.log('type', type)
        const graphData = [...this.data].map((item) => {
            //console.log(item)
            return {
                label: item.getAttribute('data-label'),
                value: item.getAttribute('data-value'),
                colour: `#${item.getAttribute('data-colour')}`
            };
        });
        const data = {
            labels: graphData.map(item => item.label),
            datasets: [
                {
                    data: graphData.map(item => item.value),
                    backgroundColor: graphData.map(item => item.colour),
                }
            ]
        };
        const config = {
            type: type || 'bar',
            data: data,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top',
                        display: type === 'pie' ? true : false,
                    },
                    // title: {
                    //     display: true,
                    //     text: 'Chart.js Pie Chart'
                    // }
                }
            },
        };
        //console.log(graphData)
        new Chart(this.canvas, config);
        //console.log('Welcome to Graphs', this)
    }
    toggleDropdown(event) {
    }
    /**
     * Creates new instances of IGraphsUtils for each `.o-navigation-bar` element,
     * and adds the necessary event listeners to support opening and closing of the navigation.
     */
    static init() {
        const graphs = [...document.querySelectorAll('[data-component="Graph"]')];
        graphs.forEach(graph => {
            const graphUtil = new Graphs(graph);
        });
    }
}
_Graphs_element = new WeakMap();
export default Graphs;
